






























































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import Component from 'vue-class-component';
import uuifComponent from '@/shared/uuifComponent';

const cssPrefix = 'idp-choice-dialog';
@Component({
  components: {
    ...uuifComponent,
  },
})
export default class IdpChoiceDialog extends SwExtendedVue {
  cssPrefix = cssPrefix;

  chooseIDP(chosenIDP: any) {
    this.$emit('chosenIDP', chosenIDP);
  }
}
